import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import type { StudentCompletionEntry } from '@/types/analytics';

interface CohortCompletionChartProps {
  data: StudentCompletionEntry[];
}

const chartConfig: ChartConfig = {
  completion_rate: {
    label: 'Completion',
    theme: { light: 'var(--chart-1)', dark: 'var(--chart-1)' },
  },
};

export function CohortCompletionChart({ data }: CohortCompletionChartProps) {
  if (data.length === 0) {
    return (
      <div className="flex h-[260px] items-center justify-center text-sm text-muted-foreground">
        Empty cohort
      </div>
    );
  }
  const points = data
    .slice(0, 15)
    .map((d) => ({
      name: d.display_name || 'Unknown',
      value: Math.round(d.completion_rate * 100),
    }));

  return (
    <ChartContainer config={chartConfig} className="h-[260px] w-full">
      <BarChart
        data={points}
        layout="vertical"
        margin={{ top: 4, right: 16, left: 0, bottom: 0 }}
      >
        <CartesianGrid horizontal={false} strokeDasharray="3 3" />
        <XAxis
          type="number"
          tickLine={false}
          axisLine={false}
          fontSize={11}
          domain={[0, 100]}
          tickFormatter={(v) => `${v}%`}
        />
        <YAxis
          dataKey="name"
          type="category"
          width={120}
          tickLine={false}
          axisLine={false}
          fontSize={11}
        />
        <ChartTooltip
          content={
            <ChartTooltipContent
              indicator="dot"
              formatter={(v) => `${v}%`}
            />
          }
        />
        <Bar dataKey="value" fill="var(--color-completion_rate)" radius={[0, 3, 3, 0]} />
      </BarChart>
    </ChartContainer>
  );
}
